/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
const randomize = require('randomatic');
window.randomize = randomize;

import 'select2';
import ScrollReveal from "scrollreveal";

import {easepick} from '@easepick/bundle';
import {RangePlugin} from '@easepick/range-plugin';
import {PresetPlugin} from '@easepick/preset-plugin';
import css_picker from '!!raw-loader!@easepick/bundle/dist/index.css';
import Headroom from "headroom.js";
import 'jquery-menu-aim';
import AlpineI18n from 'alpinejs-i18n';
import Alpine from 'alpinejs';

import Cookies from 'js-cookie'

window.Alpine = Alpine
Alpine.plugin(AlpineI18n)
Alpine.start()

import 'lazysizes';
import 'lazysizes/plugins/bgset/ls.bgset';

import GLightbox from 'glightbox';

import hoverintent from 'hoverintent';

require('jquery-ui');
require('jquery-ajax-queue');
require('./sidebar');

$(() => {
    $('.select2-enable').select2({
            theme: "bootstrap4",
            minimumResultsForSearch: 10
        }
    );
});

$.fn.select2.amd.define('select2/data/customAdapter',
    ['select2/data/array', 'select2/utils'],
    function (ArrayAdapter, Utils) {
        function CustomDataAdapter($element, options) {
            CustomDataAdapter.__super__.constructor.call(this, $element, options);
        }

        Utils.Extend(CustomDataAdapter, ArrayAdapter);
        CustomDataAdapter.prototype.updateOptions = function (data) {
            this.$element.find('option').remove();
            this.addOptions(this.convertToOptions(data));
        }
        return CustomDataAdapter;
    }
);

let pathArray = window.location.pathname.split('/');
let locale = pathArray[1];
window.appLocale = locale;

import * as translation_en from './locales/main/en.json';
import * as translation_it from './locales/main/it.json';

let messages = {
    en: translation_en,
    it: translation_it,
};

if (!(locale in messages)) {
    locale = "en";
}

window.AlpineI18n.create(locale, messages);
window.AlpineI18n.fallbackLocale = 'en';


if ($("#repository_datepicker").length) {
    const picker = new easepick.create({
        element: $("#repository_datepicker").get(0),
        css: css_picker,
        zIndex: 10,
        grid: 2,
        calendars: 2,
        lang: "it-IT",
        format: "DD-MM-YYYY",
        readonly: false,
        plugins: [
            RangePlugin,
            PresetPlugin
        ],
        PresetPlugin: {
            position: 'left',
            customLabels: [
                window.AlpineI18n.t('DatePicker.PresetPlugin.today'),
                window.AlpineI18n.t('DatePicker.PresetPlugin.yesterday'),
                window.AlpineI18n.t('DatePicker.PresetPlugin.last_7_days'),
                window.AlpineI18n.t('DatePicker.PresetPlugin.last_30_days'),
                window.AlpineI18n.t('DatePicker.PresetPlugin.this_month'),
                window.AlpineI18n.t('DatePicker.PresetPlugin.last_month')
            ]
        },
        RangePlugin: {
            delimiter: " / ",
            locale: {
                one: window.AlpineI18n.t('DatePicker.RangePlugin.one'),
                other: window.AlpineI18n.t('DatePicker.RangePlugin.other'),
            },
        },
        setup(picker) {
            picker.on('select', (evt) => {
                const elem = document.getElementById("repository_datepicker");
                const event = new Event('updateDatePicker');
                elem.dispatchEvent(event);
            })
        }
    });
}

GLightbox({
    touchNavigation: true,
    loop: true,
});

var tooltipTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="tooltip"]')
);
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl);
});

import * as Klaro from "klaro/dist/klaro-no-css";
import * as klaro_translation_en from './locales/klaro/en.json';
import * as klaro_translation_it from './locales/klaro/it.json';
import * as klaro_translation_de from './locales/klaro/de.json';
import * as klaro_translation_es from './locales/klaro/es.json';
import * as klaro_translation_pl from './locales/klaro/pl.json';
import * as klaro_translation_ro from './locales/klaro/ro.json';

let klaroEnabled = $('#klaro-status').data('enabled');
let klaroHideDeclineButton = $('#klaro-status').data('hide-decline-button');

if (klaroEnabled) {
    let cookie_types = $("#cookietype").text().split(",");

    let klaroServices = [
        {
            name: "necessary",
            required: true,
            onAccept: function (opts) {
                window.dataLayer = window.dataLayer || [];
                let eventName = 'klaro-necessary-accepted';
                dataLayer.push({'event': eventName})
            },
            onDecline: function (opts) {
                window.dataLayer = window.dataLayer || [];
                let eventName = '';
                if (opts.confirmed) {
                    eventName = 'klaro-necessary-declined';
                } else {
                    eventName = 'klaro-necessary-ignored';
                }
                dataLayer.push({'event': eventName})
            },
        }
    ]

    for (let i in cookie_types) {
        if (cookie_types[i] === "basic") {
            klaroServices.push({
                name: "basic",
                onAccept: function (opts) {
                    window.dataLayer = window.dataLayer || [];
                    let eventName = 'klaro-basic-accepted';
                    dataLayer.push({'event': eventName})
                },
                onDecline: function (opts) {
                    window.dataLayer = window.dataLayer || [];
                    let eventName = '';
                    if (opts.confirmed) {
                        eventName = 'klaro-basic-declined';
                    } else {
                        eventName = 'klaro-basic-ignored';
                    }
                    dataLayer.push({'event': eventName})
                },
            })
        } else if (cookie_types[i] === "enhancement") {
            klaroServices.push({
                name: "enhancement",
                onAccept: function (opts) {
                    window.dataLayer = window.dataLayer || [];
                    let eventName = 'klaro-enhancement-accepted';
                    dataLayer.push({'event': eventName})
                },
                onDecline: function (opts) {
                    window.dataLayer = window.dataLayer || [];
                    let eventName = '';
                    if (opts.confirmed) {
                        eventName = 'klaro-enhancement-declined';
                    } else {
                        eventName = 'klaro-enhancement-ignored';
                    }
                    dataLayer.push({'event': eventName})
                },
            })
        } else if (cookie_types[i] === "measurement") {
            klaroServices.push({
                name: "measurement",
                onAccept: function (opts) {
                    window.dataLayer = window.dataLayer || [];
                    let eventName = 'klaro-measurement-accepted';
                    dataLayer.push({'event': eventName})
                },
                onDecline: function (opts) {
                    window.dataLayer = window.dataLayer || [];
                    let eventName = '';
                    if (opts.confirmed) {
                        eventName = 'klaro-measurement-declined';
                    } else {
                        eventName = 'klaro-measurement-ignored';
                    }
                    dataLayer.push({'event': eventName})
                },
            })
        } else if (cookie_types[i] === "targeting") {
            klaroServices.push({
                name: "targeting",
                onAccept: function (opts) {
                    window.dataLayer = window.dataLayer || [];
                    let eventName = 'klaro-targeting-accepted';
                    dataLayer.push({'event': eventName})
                },
                onDecline: function (opts) {
                    window.dataLayer = window.dataLayer || [];
                    let eventName = '';
                    if (opts.confirmed) {
                        eventName = 'klaro-targeting-declined';
                    } else {
                        eventName = 'klaro-targeting-ignored';
                    }
                    dataLayer.push({'event': eventName})
                },
            })
        }
    }

    const klaroConfig = {
        acceptAll: true,
        groupByPurpose: false,
        disablePoweredBy: true,
        services: klaroServices,
        translations: {
            en: klaro_translation_en,
            it: klaro_translation_it,
            de: klaro_translation_de,
            es: klaro_translation_es,
            pl: klaro_translation_pl,
            ro: klaro_translation_ro,
        },
        hideDeclineAll: (klaroHideDeclineButton == "1")
    };

    window.klaro = Klaro;
    window.klaroConfig = klaroConfig;
    Klaro.setup(klaroConfig);
}

jQuery.expr[':'].regex = function (elem, index, match) {
    var matchParams = match[3].split(','),
        validLabels = /^(data|css):/,
        attr = {
            method: matchParams[0].match(validLabels) ?
                matchParams[0].split(':')[0] : 'attr',
            property: matchParams.shift().replace(validLabels, '')
        },
        regexFlags = 'ig',
        regex = new RegExp(matchParams.join('').replace(/^\s+|\s+$/g, ''), regexFlags);
    return regex.test(jQuery(elem)[attr.method](attr.property));
}

require('devbridge-autocomplete');

document.addEventListener("searchAutocomplete-loaded", function (e) {
    $('.search-autocomplete-input').each(function () {
        var element = $(this);
        element.autocomplete({
            groupBy: 'type',
            serviceUrl: window.location.origin + '/search_autocomplete',
            transformResult: function (response) {
                let data = JSON.parse(response);
                return {
                    suggestions: $.map(data, function (dataItemType, type) {
                        return $.map(dataItemType, function (dataItem) {
                            let image = null;

                            if (dataItem.thumbnail && dataItem.thumbnail.fallback !== "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7") {
                                image = dataItem.thumbnail;
                            } else {
                                image = dataItem.main_image;
                            }

                            return {
                                value: dataItem.title,
                                id: dataItem.id,
                                url: dataItem.canonical_url,
                                image: image,
                                data: {type: type},
                            };
                        });
                    })
                };
            },
            onSelect: function (suggestion) {
                window.location.replace(suggestion.url);
            },
            onHide: function (container) {
                $("#search-autocomplete").focus();
            },
            deferRequestBy: 500,
            formatResult(suggestion, currentValue) {
                // Do not replace anything if the current value is empty
                if (!currentValue) {
                    return suggestion.value;
                }

                var pattern = '(' + currentValue.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&") + ')';

                var value = suggestion.value
                    .replace(new RegExp(pattern, 'gi'), '<strong>$1<\/strong>')
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(/"/g, '&quot;')
                    .replace(/&lt;(\/?strong)&gt;/g, '<$1>');

                var image = "";

                if (suggestion.image) {
                    image = "<img src='" + suggestion.image.fallback + "' data-image-local='" + suggestion.image.fallback_local + "'>";
                }

                return "<div>" + image + "<span>" + value + "</span></div>"
            },
            onSearchStart: function () {
                $(this).next().next().show();
            },
            onSearchComplete: function () {
                $(this).next().next().hide();

                $("img").on("error", function () {
                    const imageLocalPath = $(this).data('image-local');
                    $(this).unbind("error");
                    $(this).attr("src", imageLocalPath);
                });
            },
            triggerSelectOnValidInput: false,
            showNoSuggestionNotice: true,
            noSuggestionNotice: autocomplete_no_results,
            appendTo: element.next().next().next().next(),
            minChars: 3,
        });
    });
});

try{
    if (typeof laravel !== 'undefined' && laravel.BREVO_EVENT_NAME !== undefined && typeof sendinblue !== 'undefined') {
        sendinblue.track(laravel.BREVO_EVENT_NAME, JSON.parse(laravel.BREVO_PROPERTIES), JSON.parse(laravel.BREVO_EVENT_DATA));
    }
}catch(e){
    console.error(e);
}

var Isotope = require("isotope-layout");

require('gasparesganga-jquery-loading-overlay');
require('jscroll');
require('cleave.js');

require('./global');
require('./flickity');
require('./profile');
require('./basket');
require('./checkout');
require('./catalog');
require('./utils');

